import {MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
export class SizesDto {
    @ApiProperty()
    @IsOptional()
    sizeId?: number;
    @ApiProperty()
    @IsNotEmpty({message:"size name should not be empty"})
    sizeName: string;

    @ApiProperty()
    @IsOptional()
    itemCategoryId: number;
    itemCategory?: string;

    @ApiProperty()
    @IsOptional()
    itemSubCategoryId: number;
    itemSubCategory?: string;

    @ApiProperty()
    @IsOptional()
    itemId: number;
    itemName?:string;

    @ApiProperty()
    isActive: boolean;
    createdAt : Date;
    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: "Created User allows maximum 40 characters" })
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
    createdUser : string;

    updatedAt : Date;
    @ApiProperty()
    @IsOptional()
    @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
    @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
    updatedUser : string;

    @ApiProperty()
    versionFlag : number;
}

